import { render, staticRenderFns } from "./StatisticsDetail.vue?vue&type=template&id=4610d56c&scoped=true"
import script from "./StatisticsDetail.vue?vue&type=script&lang=js"
export * from "./StatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./StatisticsDetail.vue?vue&type=style&index=0&id=4610d56c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610d56c",
  null
  
)

export default component.exports